module.exports = __webpack_public_path__ + "img/calendar.eb91e2e3.svg";